module.exports = __webpack_public_path__ + "img/LinkedIn.92c532fd.svg";